// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yJbq1","option":"styles_option__2c1-e","selected":"styles_selected__2XPl0"};